import { render, staticRenderFns } from "./DeliveryStatusRenderer.vue?vue&type=template&id=93337fa4&lang=pug&"
import script from "./DeliveryStatusRenderer.vue?vue&type=script&lang=ts&"
export * from "./DeliveryStatusRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryStatusRenderer.vue?vue&type=style&index=0&id=93337fa4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports